import React, { useState, useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import countrie from '../countrie/countrie';
import ReCAPTCHA from 'react-google-recaptcha';

const FormulaireInscrit = () => {
  const location = useLocation();
  const {
    formation,
    session = {},
    mode = 'Non sélectionné',
  } = location.state || {};

  const [formData, setFormData] = useState({
    civility: 'M.',
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    employeur: '',
    pays: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const Url = process.env.REACT_APP_URL_DEV;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.civility.trim())
      newErrors.civility = 'Ce champ est obligatoire.';
    if (!formData.prenom.trim()) newErrors.prenom = 'Ce champ est obligatoire.';
    if (!formData.nom.trim()) newErrors.nom = 'Ce champ est obligatoire.';
    if (!formData.email.trim()) newErrors.email = 'Ce champ est obligatoire.';
    if (!formData.telephone.trim())
      newErrors.telephone = 'Ce champ est obligatoire.';
    if (!formData.employeur.trim())
      newErrors.employeur = 'Ce champ est obligatoire.';
    if (!formData.pays.trim()) newErrors.pays = 'Ce champ est obligatoire.';
    if (!formData.message.trim())
      newErrors.message = 'Ce champ est obligatoire.';

    if (!captchaToken) newErrors.captcha = 'Veuillez valider le Captcha.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const dataToSend = {
      ...formData,
      mode,
      formationNom: formation?.formationNom || 'N/A',
      formationCode: formation?.formationCode || 'N/A',
      formationDuree: formation?.formationDuree || 'N/A',
      formationLangue: formation?.formationLangue || 'N/A',
      sessionVille: session?.sessionVille || 'N/A',
      sessionDateDebut: session?.sessionDateDebut || 'N/A',
      sessionDateFin: session?.sessionDateFin || 'N/A',
      sessionPrix: session?.sessionPrix || 'N/A',
      'g-recaptcha-response': captchaToken, // ajout du token recaptcha
    };

    try {
      const response = await axios.post(
        `${Url}/api/form/Sinscrire`,
        dataToSend,
      );
      alert('Inscription réussie !');
      setSuccess('Inscription réussie !');
      console.log("Réponse de l'API :", response.data);

      // Reset formulaire
      setFormData({
        civility: 'M.',
        prenom: '',
        nom: '',
        email: '',
        telephone: '',
        employeur: '',
        pays: '',
        message: '',
      });
      recaptchaRef.current.reset();
      setCaptchaToken(null);
    } catch (err) {
      setErrors({ global: "Une erreur est survenue lors de l'inscription." });
      setSuccess('');
      console.error("Erreur de l'API :", err);
    }
  };

  return (
    <div className="container22">
      <div className="header22">
        <h2>Formulaire d&apos;inscription</h2>
        <p className="description">{formation?.formationNom || 'N/A'}</p>
        <p>
          <strong>Code de la formation:</strong>{' '}
          {formation?.formationCode || 'N/A'}
        </p>
        <p>
          <strong>Durée de la formation:</strong>{' '}
          {formation?.formationDuree || 'N/A'}
        </p>
        <p>
          <strong>Langue de la formation:</strong>{' '}
          {formation?.formationLangue || 'N/A'}
        </p>
        <p>
          <strong>Mode de la formation:</strong> {mode || 'Non sélectionné'}
        </p>
        <h6>Session sélectionnée</h6>
        <p>
          <strong>Ville :</strong> {session.sessionVille}
        </p>
        <p>
          <strong>Date :</strong> {session.sessionDateDebut} -{' '}
          {session.sessionDateFin}
        </p>
        {mode === 'Présentiel' && (
          <p>
            <strong>Prix :</strong> {session.sessionPrix}€
          </p>
        )}
      </div>

      {errors.global && <p className="error-message">{errors.global}</p>}

      <form className="form" onSubmit={handleSubmit}>
        <select
          name="civility"
          className="form-control1"
          value={formData.civility}
          onChange={handleInputChange}
        >
          <option value="M.">M.</option>
          <option value="Mme">Mme</option>
        </select>
        {errors.civility && <p className="error-message">{errors.civility}</p>}

        <input
          type="text"
          name="prenom"
          placeholder="Prénom *"
          className="form-control"
          value={formData.prenom}
          onChange={handleInputChange}
        />
        {errors.prenom && <p className="error-message">{errors.prenom}</p>}

        <input
          type="text"
          name="nom"
          placeholder="Nom *"
          className="form-control"
          value={formData.nom}
          onChange={handleInputChange}
        />
        {errors.nom && <p className="error-message">{errors.nom}</p>}

        <input
          type="email"
          name="email"
          placeholder="Email *"
          className="form-control"
          value={formData.email}
          onChange={handleInputChange}
        />
        {errors.email && <p className="error-message">{errors.email}</p>}

        <PhoneInput
          country={'tn'}
          placeholder="N° téléphone *"
          className="form-control1"
          value={formData.telephone}
          inputStyle={{ width: '100%' }}
          onChange={(value) => setFormData({ ...formData, telephone: value })}
        />
        {errors.telephone && (
          <p className="error-message">{errors.telephone}</p>
        )}

        <input
          type="text"
          name="employeur"
          placeholder="Employeur *"
          className="form-control"
          value={formData.employeur}
          onChange={handleInputChange}
        />
        {errors.employeur && (
          <p className="error-message">{errors.employeur}</p>
        )}

        <select
          name="pays"
          className="form-control1"
          value={formData.pays}
          onChange={handleInputChange}
        >
          <option value="">Sélectionnez votre pays</option>
          {countrie.map((c, index) => (
            <option key={index} value={c}>
              {c}
            </option>
          ))}
        </select>
        {errors.pays && <p className="error-message">{errors.pays}</p>}

        <textarea
          name="message"
          placeholder="Message *"
          className="form-control"
          rows="4"
          value={formData.message}
          onChange={handleInputChange}
        ></textarea>
        {errors.message && <p className="error-message">{errors.message}</p>}

        {/* Captcha */}
        <div style={{ margin: '20px 0', textAlign: 'center' }}>
          <ReCAPTCHA
            sitekey="6Lf8vqIrAAAAAJSU8cRjXvxEO3864ewH_Np9j9I_" // ⚠️ mets ta vraie clé ici
            ref={recaptchaRef}
            onChange={(token) => setCaptchaToken(token)}
          />
          {errors.captcha && <p className="error-message">{errors.captcha}</p>}
        </div>

        <button type="submit" className="btn-submit">
          {mode === 'En ligne' ? 'Demande Un Devis' : 'Envoyer'}
        </button>
        {success && (
          <p style={{ color: 'green', marginTop: '10px' }}>{success}</p>
        )}
      </form>
    </div>
  );
};

export default FormulaireInscrit;
